// extracted by mini-css-extract-plugin
export default {"p_content":"_7692fa7c33"};